import React from 'react';
import './DancingBeetle.css';

const DancingBeetle = () => {
  return (
    <div className="beetle-container">
      <div className="beetle-wrapper">
        <div className="beetle">
          {/* Head */}
          <div className="beetle-head">
            <div className="antenna left-antenna"></div>
            <div className="antenna right-antenna"></div>
            <div className="eye left-eye"></div>
            <div className="eye right-eye"></div>
          </div>
          
          {/* Body */}
          <div className="beetle-body">
            <div className="body-stripe stripe-1"></div>
            <div className="body-stripe stripe-2"></div>
            <div className="body-stripe stripe-3"></div>
          </div>
          
          {/* Wings */}
          <div className="wing left-wing"></div>
          <div className="wing right-wing"></div>
          
          {/* Legs */}
          <div className="leg front-left-leg"></div>
          <div className="leg front-right-leg"></div>
          <div className="leg middle-left-leg"></div>
          <div className="leg middle-right-leg"></div>
          <div className="leg back-left-leg"></div>
          <div className="leg back-right-leg"></div>
        </div>
      </div>
      <div className="dance-floor">
        <div className="floor-pattern"></div>
      </div>
    </div>
  );
};

export default DancingBeetle;